var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomNavScheduleTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.16667,
    y: 3.16667,
    width: 23.6667,
    height: 22.6667,
    rx: 2.83333,
    stroke: "#004FEC",
    strokeWidth: 2.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 7H2V25H26V7ZM19.8249 12.825C20.2805 12.3693 20.2805 11.6307 19.8249 11.175C19.3693 10.7194 18.6306 10.7194 18.175 11.175C17.1282 12.2219 15.4558 13.9361 14.0498 15.3838C13.3514 16.103 12.717 16.758 12.255 17.2356L9.75555 15.1111C9.2646 14.6938 8.52832 14.7535 8.11103 15.2444C7.69374 15.7354 7.75344 16.4716 8.24439 16.8889L11.5778 19.7223L12.4124 20.4316L13.173 19.6434L12.3334 18.8333C13.173 19.6434 13.173 19.6434 13.173 19.6434L13.1732 19.6432L13.1738 19.6426L13.1762 19.64L13.1861 19.6298L13.2248 19.5898L13.3737 19.4356C13.503 19.3017 13.6901 19.1081 13.9211 18.8693C14.3832 18.3915 15.021 17.7329 15.7236 17.0095C17.1309 15.5605 18.7918 13.858 19.8249 12.825Z",
    fill: "#004FEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#004FEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#004FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavScheduleTrue);
export default __webpack_public_path__ + "static/media/bottom_nav_schedule_true.0930564237253213f4f674560b5c10e7.svg";
export { ForwardRef as ReactComponent };